<template>
  <custom-collapse-item
    ref="collapseItem"
    auto
    class="my-3 collapse-item section bg-gray"
    expanded-icon="fas fa-chevron-circle-right color-gray-7"
    minimized-icon="fas fa-chevron-circle-down color-warning"
    parent-id="factors-collapse"
    read-only-icon="fas fa-plus-circle color-gray-2"
    start-expanded
    title="GOE"
    @expandButtonClick="$emit('expandButtonClick')"
  >
    <div class="bg-white p-3 rounded">
      <div class="goe-item-card p-3">
        <div class="row align-items-end">
          <div class="col-md-5 mb-3">
            <validation-provider
              v-if="!isReadOnly"
              v-slot="{ errors }"
              name="Nivel Requerido de la Profesión"
              rules="required"
            >
              <label>Nivel Requerido de la Profesión:</label>
              <custom-drop-down
                clearable
                :disabled="isReadOnly"
                fieldkey="id"
                fieldname="name"
                :options="options"
                placeholder="Seleccione"
                :value="item.requiredLevel"
                @input="updateItem('requiredLevel', $event)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

            <div v-else>
              <label>Nivel Requerido de la Profesión:</label>
              <span class="d-block mt-1 text-muted">
                {{ item.requiredLevel?.name | empty }}
              </span>
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <validation-provider
              v-if="!isReadOnly"
              v-slot="{ errors }"
              name="Perfil del Evaluado"
              rules="required"
            >
              <label>Perfil del Evaluado:</label>
              <custom-drop-down
                clearable
                :disabled="isReadOnly"
                fieldkey="id"
                fieldname="name"
                :options="options"
                placeholder="Seleccione"
                :value="item.evaluatedLevel"
                @input="updateItem('evaluatedLevel', $event)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

            <div v-else>
              <label>Perfil del Evaluado:</label>
              <span class="d-block mt-1 text-muted">
                {{ item.evaluatedLevel?.name | empty }}
              </span>
            </div>
          </div>

          <div
            class="col-12 col-lg-3 d-flex justify-content-lg-end goe-answer-wrapper"
          >
            <validation-provider
              v-slot="{ errors }"
              class="w-100"
              name="Resultado del Pareo"
              rules="required"
            >
              <input type="hidden" :value="item.selectedAnswer" />

              <div class="d-flex flex-wrap justify-content-lg-end">
                <button
                  v-for="answer in answers"
                  :key="`goe-answer-${answer.id}`"
                  class="goe-answer-btn"
                  :class="{
                    active:
                      item.selectedAnswer &&
                      item.selectedAnswer.id === answer.id,
                  }"
                  :disabled="isReadOnly"
                  type="button"
                  @click="updateItem('selectedAnswer', answer)"
                >
                  <i class="far fa-check-circle d-block mb-1" />
                  {{ answer.name }}
                </button>
              </div>

              <small class="text-danger d-block mt-1">
                {{ errors[0] }}
              </small>
            </validation-provider>
          </div>
        </div>

        <div>
          <label>Observaciones:</label>
          <custom-text-area
            v-model="model.comment"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            :disabled="isReadOnly"
            :maxlength="5000"
            placeholder="Comentario"
            show-char-count
          />
        </div>
      </div>
    </div>
  </custom-collapse-item>
</template>

<script>
import CustomCollapseItem from '@/components/common/CustomCollapseItem.vue';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'GoeOccupationalFactors',
  components: {
    CustomCollapseItem,
    CustomDropDown,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    item() {
      return this.model.item || {};
    },
    options() {
      return this.model.options || [];
    },
    answers() {
      return this.model.answers || [];
    },
  },
  methods: {
    updateItem(field, value) {
      this.model = {
        ...this.model,
        item: {
          ...this.item,
          [field]: value,
        },
      };
    },
    setExpanded(expand) {
      if (this.$refs.collapseItem) {
        this.$refs.collapseItem.isExpended = expand;
      }
    },
  },
};
</script>

<style scoped>
.goe-item-card {
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  background: #fafafa;
}

.goe-answer-wrapper {
  border-left: 1px solid #e1e1e1;
}

.goe-answer-btn {
  min-width: 95px;
  border: 1px solid #f2f2f2;
  background: #f7f7f7;
  color: #a8b7b5;
  padding: 0.65rem 0.75rem;
  margin-left: 0.45rem;
  border-radius: 6px 6px 0 0;
  font-size: 12px;
}

.goe-answer-btn i {
  font-size: 16px;
  color: #9bb0ad;
}

.goe-answer-btn.active {
  background: #2db782;
  border-color: #2db782;
  color: #fff;
}

.goe-answer-btn.active i {
  color: #fff;
}

.goe-answer-btn:disabled.active {
  background: #3f5b60;
  border-color: #3f5b60;
  color: #fff;
}

.goe-answer-btn:disabled:not(.active) {
  background: #f4f4f4;
  border-color: #f4f4f4;
  color: #aeb8b6;
  opacity: 1;
}
</style>
